import { useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Search, X, ArrowUpDown } from 'lucide-react';

export const EmployeeSearch = ({ employees, onFilteredEmployees }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');

  const handleSearch = (term) => {
    setSearchTerm(term);
    filterAndSort(term, sortBy, sortOrder);
  };

  const handleSort = (newSortBy) => {
    const newSortOrder = sortBy === newSortBy && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortBy(newSortBy);
    setSortOrder(newSortOrder);
    filterAndSort(searchTerm, newSortBy, newSortOrder);
  };

  const filterAndSort = (term, sortField, order) => {
    let filtered = employees;

    // Filtrar por término de búsqueda
    if (term) {
      filtered = employees.filter(employee =>
        employee.name.toLowerCase().includes(term.toLowerCase()) ||
        employee.position.toLowerCase().includes(term.toLowerCase()) ||
        (employee.rut && employee.rut.toLowerCase().includes(term.toLowerCase()))
      );
    }

    // Ordenar
    filtered = [...filtered].sort((a, b) => {
      let aValue, bValue;
      
      switch (sortField) {
        case 'name':
          aValue = a.name.toLowerCase();
          bValue = b.name.toLowerCase();
          break;
        case 'startDate':
          aValue = new Date(a.startDate);
          bValue = new Date(b.startDate);
          break;
        case 'availableDays':
          aValue = a.accumulatedDays + a.progressiveDays + (a.additionalDays || 0) - a.usedDays;
          bValue = b.accumulatedDays + b.progressiveDays + (b.additionalDays || 0) - b.usedDays;
          break;
        default:
          return 0;
      }

      if (aValue < bValue) return order === 'asc' ? -1 : 1;
      if (aValue > bValue) return order === 'asc' ? 1 : -1;
      return 0;
    });

    onFilteredEmployees(filtered);
  };

  const clearSearch = () => {
    setSearchTerm('');
    filterAndSort('', sortBy, sortOrder);
  };

  const getSortLabel = (field) => {
    switch (field) {
      case 'name': return 'Nombre';
      case 'startDate': return 'Fecha Ingreso';
      case 'availableDays': return 'Días Disponibles';
      default: return field;
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-6">
      <div className="relative flex-1">
        <Search 
          size={16} 
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
        />
        <Input
          placeholder="Buscar por nombre, cargo o RUT..."
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          className="pl-10 pr-10"
        />
        {searchTerm && (
          <Button
            variant="ghost"
            size="sm"
            onClick={clearSearch}
            className="absolute right-1 top-1/2 transform -translate-y-1/2 h-6 w-6 p-0"
          >
            <X size={12} />
          </Button>
        )}
      </div>

      <div className="flex gap-2">
        <Select value={sortBy} onValueChange={handleSort}>
          <SelectTrigger className="w-[180px]">
            <ArrowUpDown size={16} className="mr-2" />
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="name">Ordenar por Nombre</SelectItem>
            <SelectItem value="startDate">Ordenar por Ingreso</SelectItem>
            <SelectItem value="availableDays">Ordenar por Disponibles</SelectItem>
          </SelectContent>
        </Select>

        <Button
          variant="outline"
          size="sm"
          onClick={() => handleSort(sortBy)}
          className="px-3"
        >
          {sortOrder === 'asc' ? '↑' : '↓'}
        </Button>
      </div>
    </div>
  );
};
